<template>
  <div id="pageAplicacion">
    <v-container grid-list-xl fluid>
      <div v-if="showAlert">
        <alert-empty></alert-empty>
      </div>
      <v-layout row wrap>
        <v-container grid-list-xl fluid>
          <v-layout justify-center>
            <v-flex lg12>
              <v-container>
                <!-- FILTRO DE GRAFICA  -->
                <v-layout>
                  <!-- FECHA EVOLUCION       -->
                  <v-flex xs12 md4>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fechaEvolucion"
                          label="Fecha"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaEvolucion"
                        @input="menu1 = false"
                        no-title
                        locale="es"
                        first-day-of-week="1"
                      ></v-date-picker>
                    </v-menu>
                    <!-- NIVEL -->
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="nivelValue"
                      :items="nivelSelect"
                      item-value="description"
                      item-text="description"
                      label="Nivel"
                    ></v-select>
                  </v-flex>
                  <v-btn
                    fab
                    dark
                    color="teal"
                    title="Filtrar evolucion"
                    @click="filter()"
                  >
                    <v-icon dark>filter_list</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    dark
                    color="red darken-4"
                    title="Limpiar filtros"
                    @click="clear()"
                  >
                    <v-icon dark>clear_all</v-icon>
                  </v-btn>
                </v-layout>
                <!-- FILTRO DE GRAFICA  -->
                <v-layout>
                  <v-flex>
                    <div v-if="loading">
                      <loading></loading>
                    </div>
                    <div v-else>
                      <grafica-material-evolucion
                        v-for="(graf, indexChart) in pruebas"
                        :key="indexChart"
                        :res="res[indexChart]"
                        :titulo="titleGrafica[indexChart]"
                        :titleIn="titleTest[indexChart]"
                        :fechaProgreso="fechaFiltro"
                        :nivelFiltro="nivelFiltro"
                      ></grafica-material-evolucion>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import GraficaMaterialEvolucion from "@/modules/distribucion/views/evolucion/GraficaMaterialEvolucion.vue";
export default {
  components: {
    Loading,
    AlertEmpty,
    GraficaMaterialEvolucion,
  },
  mixins: [misMixins],
  data: () => ({
    nivelSelect: "",
    nivelValue: "",
    tipoMaterialValue: "",
    tipoMaterialSelect: "",
    contratoId: "",
    subProceso: "",
    fechaEvolucion: "",
    menu1: false,
    color: Material,
    selectedTab: "tab-1",
    indexChart: 0,
    res: [],
    titleGrafica: [],
    titleTest: [],
    pruebas: [],
    showAlert: false,
    loading: false,
    fechaFiltro: "",
    nivelFiltro: "",
  }),

  computed: {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.loadSelects();
  },
  mounted() {},
  methods: {
    fechaAnterior() {
      let fechaHoy = new Date();
      let fechaAyer = fechaHoy.setDate(fechaHoy.getDate() - 1);
      let formatoAyer = new Date(fechaAyer).toISOString().substr(0, 10);
      this.fechaEvolucion = formatoAyer;
    },

    async loadSelects() {
      this.nivelSelect = await this.loadNivel();
      //Con esto buscamos todos los valores y hacemos que printe en los filtros i en pantalla el ultimo
      this.pruebas = [];
      this.pruebas = await this.getUltimaFecha();
      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.tipoMaterialValue =
          this.pruebas[this.pruebas.length - 1].tipoMaterial;
        this.nivelValue = this.pruebas[this.pruebas.length - 1].nivel;
        this.fechaEvolucion = this.formatoFechaEuropea(
          this.pruebas[this.pruebas.length - 1].fechaProgreso
        );
      } else {
        this.showAlert = true;
      }
      this.loadData();
    },
    async getUltimaFecha() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        // contratoId:this.contratoId,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        nivel: null,
        tipoMaterial: null,
        tipoDocumento: null,
        tipoPrueba: null,
        fecha_progreso: null,
      };
      return await axios
        .post("/evolucionFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    formatoFechaEuropea(f) {
      // Convierte un texto de la forma europea a la forma americana
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    async loadTipoMaterial() {
      return await axios
        .get(
          "/evolucionTipoMaterial/" + this.contratoId + "/" + this.subProceso
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadNivel() {
      return await axios
        .get("/evolucionNivel/" + this.contratoId + "/" + this.subProceso)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else {
            console.log(error);
          }
        });
    },
    filter() {
      this.loadData();
    },
    clear() {
      this.nivelValue = "";
    },
    async loadData() {
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadFilter();
      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.pruebas.forEach((m) => {
          let data = [];
          this.titleTest[this.indexChart] = m.tipoPrueba;
          this.titleGrafica[this.indexChart] =
            "Tipo de Prueba: " + m.tipoPrueba;
          data.push(
            {
              value: m.realizado,
              name: "Enviados",
            },
            {
              value: m.recibido,
              name: "Recibidos",
            },
            {
              value: m.total,
              name: "Pte envio",
            }
          );

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
      } else {
        this.showAlert = true;
      }
      this.loading = false;
    },
    async loadFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      this.fechaFiltro = this.fechaEvolucion;
      this.nivelFiltro = this.nivelValue.description;

      this.body = {
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        nivel:
          this.nivelValue.description === undefined
            ? this.nivelValue
            : this.nivelValue.description,
        //tipoMaterial: this.tipoMaterialValue.description===undefined ? this.tipoMaterialValue : this.tipoMaterialValue.description ,
        fecha_progreso: this.fechaFiltro,
      };
      return await axios
        .post("/evolucionFilterDist", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
